import React from 'react'
import PropTypes from 'prop-types'

import moment from 'moment'
import Menu from 'material-ui/Menu'
import MenuItem from 'material-ui/MenuItem'
import FlatButton from 'material-ui/FlatButton'
import Popover from 'material-ui/Popover'
import FontIcon from 'material-ui/FontIcon'

export default class TimePeriod extends React.Component {

  static PERIOD_STRINGS = {
    w: 'Week',
    m: 'Month'
  }

  static propTypes = {
    selectedPeriod: PropTypes.string.isRequired,
    onChangePeriod: PropTypes.func.isRequired
  }

  static getSelectedPeriodDuration(period) {
    const number = period.substring(0, period.length - 1)
    const periodInterval = period.substring(period.length - 1)

    return moment.duration(parseInt(number), periodInterval)
  }

  static getSelectedPeriodText(period) {
    const number = period.substring(0, period.length - 1)
    const periodInterval = period.substring(period.length - 1)

    let periodString = TimePeriod.PERIOD_STRINGS[periodInterval]
    if (number !== '1') {
      periodString += 's'
    }

    return `${number}  ${periodString}`
  }

  constructor(props) {
    super(props)
    this.state = {
      openMenu: false
    }
  }

  handleChangePeriod = newPeriod => {
    this.setState({
      openMenu: false
    })
    this.props.onChangePeriod(newPeriod)
  }

  renderMenuItem = period => {
    const checked = this.props.selectedPeriod === period
    return (
      <MenuItem
        primaryText={TimePeriod.getSelectedPeriodText(period)}
        checked={checked}
        onTouchTap={() => this.handleChangePeriod(period)}
        insetChildren={!checked}/>
    )
  }

  render() {
    return (
      <div
        ref={root => this.root = root}
        style={{ marginLeft: 8, backgroundColor: '#fafafa' }}>
        <FlatButton
          style={{ width: 152,
            border: '1px solid #dbdee1' }}
          onTouchTap={() => this.setState({ openMenu: true })}>
          <div
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <span
              style={{
                textTransform: 'none',
                fontSize: 14
              }}>
              {'Period: ' + TimePeriod.getSelectedPeriodText(this.props.selectedPeriod)}
            </span>
            <FontIcon
              className="material-icons"
              color='#4d6f7f'
              style={{ paddingLeft: 5 }}>
              keyboard_arrow_down
            </FontIcon>
          </div>
        </FlatButton>

        <Popover
          style={{ width: 152 }}
          open={this.state.openMenu}
          anchorEl={this.root}
          anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
          targetOrigin={{horizontal: 'right', vertical: 'top'}}
          onRequestClose={() => this.setState({ openMenu: false })}>
          <Menu style={{ width: 100 }}>
            { this.renderMenuItem('1w') }
            { this.renderMenuItem('2w') }
            { this.renderMenuItem('3w') }
            { this.renderMenuItem('4w') }
          </Menu>
        </Popover>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/common/date/TimePeriod.js